import { X, CheckCircle } from "@phosphor-icons/react";
import { METHOD_LABELS } from "@/components/finance/apShared";

export default function BillFormModal({ showBill, setShowBill, suppliers, error, onSubmit }) {
  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-6 overflow-y-auto" onClick={() => setShowBill(null)}>
      <div className="glass max-w-lg w-full p-8 my-6" onClick={(e) => e.stopPropagation()} data-testid="bill-modal">
        <div className="flex items-center justify-between mb-4">
          <div>
            <div className="overline text-zinc-500">{showBill.editingId ? "EDITAR CONTA" : "NOVA CONTA A PAGAR"}</div>
            <h2 className="font-head text-2xl font-black">{new Date(showBill.form.due_date + "T12:00:00").toLocaleDateString("pt-BR")}</h2>
          </div>
          <button onClick={() => setShowBill(null)}><X size={20} /></button>
        </div>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="label">Fornecedor</label>
            <select
              className="input"
              value={showBill.form.supplier_id}
              onChange={(e) => {
                const s = suppliers.find((x) => x.id === e.target.value);
                setShowBill({ ...showBill, form: { ...showBill.form, supplier_id: e.target.value, supplier_name: s?.name || showBill.form.supplier_name } });
              }}
              data-testid="bill-supplier"
            >
              <option value="">— Livre / sem cadastro —</option>
              {suppliers.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
            </select>
            {!showBill.form.supplier_id && (
              <input
                className="input mt-2"
                placeholder="Nome do fornecedor (livre)"
                value={showBill.form.supplier_name}
                onChange={(e) => setShowBill({ ...showBill, form: { ...showBill.form, supplier_name: e.target.value } })}
                data-testid="bill-supplier-free"
              />
            )}
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="label">Valor (R$) *</label>
              <input type="number" step="0.01" min="0" className="input font-mono" required value={showBill.form.amount} onChange={(e) => setShowBill({ ...showBill, form: { ...showBill.form, amount: e.target.value } })} data-testid="bill-amount" />
            </div>
            <div>
              <label className="label">Vencimento *</label>
              <input type="date" className="input font-mono" required value={showBill.form.due_date} onChange={(e) => setShowBill({ ...showBill, form: { ...showBill.form, due_date: e.target.value } })} data-testid="bill-due" />
            </div>
          </div>
          <div>
            <label className="label">Forma de Pagamento *</label>
            <div className="grid grid-cols-4 gap-2" data-testid="bill-method-group">
              {["boleto", "pix", "cartao", "dinheiro"].map((m) => (
                <button
                  key={m}
                  type="button"
                  onClick={() => setShowBill({ ...showBill, form: { ...showBill.form, payment_method: m } })}
                  className={`p-3 border-2 text-center text-xs font-bold uppercase tracking-widest ${showBill.form.payment_method === m ? "bg-black text-white border-black" : "bg-white border-zinc-300 hover:border-black"}`}
                  data-testid={`bill-method-${m}`}
                >
                  {METHOD_LABELS[m]}
                </button>
              ))}
            </div>
          </div>
          <div>
            <label className="label">Descrição / Observação</label>
            <textarea className="input min-h-[60px]" value={showBill.form.description} onChange={(e) => setShowBill({ ...showBill, form: { ...showBill.form, description: e.target.value } })} data-testid="bill-desc" />
          </div>
          {!showBill.editingId && (
            <div className="border-t pt-4">
              <label className="label">Recorrência</label>
              <select className="input" value={showBill.form.recurring} onChange={(e) => setShowBill({ ...showBill, form: { ...showBill.form, recurring: e.target.value } })} data-testid="bill-recurring">
                <option value="none">Não repete</option>
                <option value="monthly">Todo mês</option>
                <option value="quarterly">A cada 3 meses</option>
                <option value="yearly">Todo ano</option>
              </select>
              {showBill.form.recurring !== "none" && (
                <div className="mt-2">
                  <label className="label text-[10px]">Repetir até (opcional — padrão 12 meses)</label>
                  <input type="date" className="input font-mono" value={showBill.form.recurring_end} onChange={(e) => setShowBill({ ...showBill, form: { ...showBill.form, recurring_end: e.target.value } })} data-testid="bill-recurring-end" />
                </div>
              )}
            </div>
          )}
          {error && <div className="border border-[#E60000] bg-red-50 text-[#E60000] text-sm px-3 py-2">{error}</div>}
          <div className="flex gap-3 pt-2">
            <button type="button" className="btn btn-ghost flex-1" onClick={() => setShowBill(null)}>Cancelar</button>
            <button type="submit" className="btn flex-1" data-testid="bill-save"><CheckCircle size={16} weight="bold" /> Salvar</button>
          </div>
        </form>
      </div>
    </div>
  );
}
